<!--
File: side-menu.component.html
Project: catalog-cloud
File Created: Wednesday, 22nd December 2021 12:48:17
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Thursday, 24th October 2024 9:25:33 am
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->
<button
  *ngIf="isVisible"
  mat-flat-button
  color="primary"
  aria-label="user-menu-button"
>
  <span> {{ "ACTIONS" | translate }} </span>
  <i matSuffix>expand_more</i>
</button>

<p-menu>
  <ng-container *ngFor="let button of actionsBunttos" [ngSwitch]="button.type">
    <button
      *ngSwitchCase="'button'"
      mat-menu-item
      [ngClass]="{
        active: button.active
      }"
      [disabled]="button.disabled"
      (click)="button.clickButton()"
    >
      <!-- <mat-icon>{{ button.icon }}</mat-icon> -->
      <i>{{ button.icon }}</i>
      <span>{{ button.tooltip | translate }}</span>
    </button>
    <p-divider type="solid" *ngSwitchCase="'separator'"></p-divider>
  </ng-container>
</p-menu>

